<script>
export default {
    type: "mscombidy2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        // caption: "Split of visitors by Channels",
                        // placevaluesinside: "1",
                        // showvalues: "1",
                        // plottooltext:
                        //     "<b>$dataValue</b> $seriesName Pada $label",
                        theme: "fusion",
                        caption: "JUMLAH HASIL PELBAGAI",
                        // xAxisname: "Month",
                        pYAxisName: "Jumlah Kutipan",
                        sYAxisName: "Peratus %",
                        // numberPrefix: "$",
                        sNumberSuffix: "%",
                        // sYAxisMaxValue: "300",
                    },
                    categories: [
                        {
                            category: [
                                {
                                    label: "April 2022",
                                },
                                {
                                    label: "April 2021",
                                },
                                {
                                    label: "April 2020",
                                },
                            ],
                        },
                    ],
                    dataset: [
                        {
                            seriesname: "Anggaran",
                            color: "#F76E11",
                            data: [
                                { value: "193972620.00" },
                                { value: "180663350.00 " },
                                { value: "160836506.00" },
                            ],
                        },
                        {
                            seriesname: "Kutipan",
                            color: "#FF9F45",
                            data: [
                                { value: "30660122.75 " },
                                { value: "24211548.59 	" },
                                { value: "33046268.36 " },
                            ],
                        },
                        {
                            seriesName: "Peratus %",
                            parentYAxis: "S",
                            renderAs: "line",
                            showValues: "0",
                            color: "#000000",
                            data: [
                                {
                                    value: "15.81",
                                },
                                {
                                    value: "13.40",
                                },
                                {
                                    value: "20.55",
                                },
                            ],
                        },
                    ],
                },
};
</script>
